const Wave = ({ type = "up", color = "#FFFFFF" }) => {
  const isUp = type === "up";

  return (
    <div className={`${isUp ? "wave-up" : "wave-down lg:-mt-0 -mt-1"}`}>
      <svg viewBox="0 0 1920 315" preserveAspectRatio="xMinYMin meet" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" >
        <defs>
          <rect id="path-1" x="0" y="0" width="1920" height={isUp ? "238" : "250"} />
          <path id="path-3"
            d={ 
              isUp ? "M0,162.263331 C185.6912,80.1788832 379.291437,40.824438 580.800709,44.1999951 C883.064617,49.2633306 1195.90198,181.263331 1681.42752,181.263331 C1762.69626,181.263331 1842.22042,174.929997 1920,162.263331 L1920,422.263331 L0,422.263331 L0,162.263331 Z" 
              : "M0,214.976371 C185.6912,106.706817 379.291437,54.8029941 580.800709,59.2649034 C883.064617,65.9577675 1195.90198,240.439201 1681.42752,240.439201 C1762.69626,240.439201 1842.22042,231.951591 1920,214.976371 L1920,559 L0,559 L0,214.976371 Z" 
            } />
          <filter id="filter-4" x="-1.5%" y={isUp ? "-7.9%" : "-6.0%"} width="103.0%" height={isUp ? "115.3%" : "111.6%"} filterUnits="objectBoundingBox" >
            <feOffset dx="0" dy="-1" in="SourceAlpha" result="shadowOffsetOuter1" />
            <feGaussianBlur stdDeviation="9.5" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
            <feColorMatrix type="matrix" values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.13 0" in="shadowBlurOuter1" />
          </filter>
        </defs>

        <g fill="none" fillRule="evenodd" transform={ isUp ? "translate(0, 77)" : "translate(960, 115) scale(1, -1) translate(-960, -115)" } >
          <mask id="mask-2" fill="white">
            <use xlinkHref="#path-1" />
          </mask>
          <g mask="url(#mask-2)">
            <use fill="black" fillOpacity="1" filter="url(#filter-4)" xlinkHref="#path-3" />
            <use fill={color} fillRule="evenodd" xlinkHref="#path-3" />
          </g>
        </g>
      </svg>
    </div>
  );
};

export default Wave;